/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @21-07-2019 20:16:42
*/

function setIsUserLoggedInTrue(){
	return {
		type: 'SET_LOGGED_IN_TRUE'
	}
}

function setIsUserLoggedInFalse(){
	return {
		type: 'SET_LOGGED_IN_FALSE'
	}
}

function setLocale(newLocale){
	return {
		type: 'SET_LOCALE',
		newLocale:newLocale
	}
}
function setContextParameters(key,payload){
	return {
		type: 'SET_CONTEXT_PARAMETERS',
		key:key,
		payload:payload
	}
}
function setConfigurationValues(payload){
	return {
		type: 'SET_CONFIGURATION_VALUES',
		payload:payload
	}
}

function setfeasibilityResposne(key,payload){
	return {
		type: 'SET_FEASIBILITY_RESPOSNSE',
		key:key,
		payload:payload
	}
}

function setCache(key,payload){
	return {
		type: 'SET_CACHE',
		key:key,
		payload:payload
	}
}

function setCurrentPage(key,payload){
	return {
		type: 'SET_CURRENT_PAGE',
		key:key,
		payload:payload
	}
}

function setLoginPage(key,payload){
	return {
		type: 'SET_LOGIN_PAGE',
		key:key,
		payload:payload
	}
}

function setSiteKey(key,payload){
	return {
		type: 'SET_SITE_KEY',
		key:key,
		payload:payload
	}
}

function setRegisterDetails(key,payload){
	return {
		type: 'SET_REGISTER_DETAILS',
		key:key,
		payload:payload
	}
}

function setChangeEquipmentDetails(key,payload){
	return {
		type: 'SET_CHANGE_EQUIPMENT_DETAILS',
		key:key,
		payload:payload
	}
}

function setOrderDetails(key,payload){
	return {
		type: 'SET_ORDER_DETAILS',
		key:key,
		payload:payload
	}
}

function setUserRegisterDetails(key,payload){
	return {
		type: 'SET_USER_REGISTER_DETAILS',
		key:key,
		payload:payload
	}
}

function setUserDetails(key,payload){
	return {
		type: 'SET_USER_DETAILS',
		key:key,
		payload:payload
	}
}

function setForgetPasswordDetails(key,payload){
	return {
		type: 'SET_FORGET_PASSWORD_DETAILS',
		key:key,
		payload:payload
	}
}

function setPlanDetails(key,payload){
	return {
		type: 'SET_PLAN_DETAILS',
		key:key,
		payload:payload
	}
}

function setSwitchAccountModalTrue(){
	return {
		type: 'SET_SWITCH_ACCOUNT_MODAL_TRUE'
	}
}

function setSwitchAccountModalFalse(){
	return {
		type: 'SET_SWITCH_ACCOUNT_MODAL_FALSE'
	}
}


module.exports={setIsUserLoggedInTrue,setRegisterDetails,setIsUserLoggedInFalse,setLocale,setCache,setCurrentPage,setPlanDetails,setUserRegisterDetails,setUserDetails,setLoginPage,setForgetPasswordDetails,setSwitchAccountModalTrue,setSwitchAccountModalFalse,setContextParameters,setfeasibilityResposne,setOrderDetails,setChangeEquipmentDetails,setConfigurationValues,setSiteKey}





// import Network from '../Utils/network.js'

// export const setIsUserLoggedInTrue=()=>{
// 	return {
// 		type: 'SET_LOGGED_IN_TRUE'
// 	}
// }

// export const setIsUserLoggedInFalse=()=>{
// 	return {
// 		type: 'SET_LOGGED_IN_FALSE'
// 	}
// }

// export const setLocale=(newLocale)=>{
// 	return {
// 		type: 'SET_LOCALE',
// 		newLocale:newLocale
// 	}
// }

// export const setIsLoadingTrue=()=>{
// 	return {
// 		type: 'SET_LOADING_TRUE'
// 	}
// }

// export const setIsLoadingFalse=()=>{
// 	return {
// 		type: 'SET_LOADING_FALSE'
// 	}
// }

// //=============================================================================

// export const validateLogin=(dataToSend)=>{
// 	return (dispatch) =>  {
// 		dispatch(setIsLoadingTrue());
// 		Network.executeAxios("loginCheck","POST",{"username":dataToSend.username,"password":dataToSend.password},(response) => {
// 			console.log("response in setIsUserLoggedInTrue action >>",response);
// 			dispatch(setIsLoadingFalse());
// 			if(response.STATUS == "SUCCESS"){
//                 return dispatch(setIsUserLoggedInTrue());
//             }else{
//             	return dispatch(setIsUserLoggedInFalse());
//             }
// 		});
// 	}
// }
